import { render } from "./CampaignsAutomationList.vue?vue&type=template&id=9ea46fbe&scoped=true"
import script from "./CampaignsAutomationList.vue?vue&type=script&lang=ts"
export * from "./CampaignsAutomationList.vue?vue&type=script&lang=ts"

import "./CampaignsAutomationList.vue?vue&type=style&index=0&id=9ea46fbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9ea46fbe"

export default script